<ng-select appendTo="body" #selectElement class="custom" [class]="customClass" [multiple]="multiple"
  [formControl]="formControlNameSelect" [placeholder]="placeHolder" (change)="change($event)"
  [bindLabel]="bindLabelSelect"
  (scrollToEnd)="getNextBatchFiltered()" [typeahead]=input$>
  <ng-template ng-label-tmp let-item="item">
    <ng-container *ngIf="item?.id !== undefined && item?.id !== null; else placeholderTpl">
      <span *ngIf="this.displayName === false">{{ getItemDescription(item) }}</span>
      <span *ngIf="this.displayName === true">{{ getItemDisplay(item) }}</span>
    </ng-container>
    <ng-template #placeholderTpl>
      {{ placeHolder }}
    </ng-template>
  </ng-template>
  <ng-template ng-header-tmp>
    <label class="form-control">Resultados: {{ filteredModelList.length }} de
      {{totalElements}}</label>
  </ng-template>
  <ng-container>
    <ng-option *ngFor="let model of filteredModelList" [value]="model">
      <span [title]="getItemDescription(model)" *ngIf="this.displayName === false">{{ getItemDescription(model) }}</span>
      <span [title]="getItemDisplay(model)" *ngIf="this.displayName === true">{{ getItemDisplay(model) }}</span>
    </ng-option>
  </ng-container>

  <ng-template ng-footer-tmp>
    <div class="input-group">
      <input type="text" class="form-control" placeholder="Buscar" #box />
      <button type="button" class="btn btn-primary btn-search-lib" (click)="filterSearch(box.value)"
        style="height: auto"><span class="material-icons">search</span></button>
    </div>
    <div class="input-group">
      <label class="form-control">Limpiar</label>
      <button type="button" class="btn btn-outline-primary btn-limpiar" (click)="clearFilter()"><span
          class="material-icons">close</span></button>
    </div>
  </ng-template>
</ng-select>
